import * as IoC from 'typescript-ioc';
import { IApiClient } from '../../infrastructure/api-client';
import {
    IBlueprintEmailConfigurationDAO,
    IBlueprintEmailConfigurationForm,
    IBlueprintEmailRequestParams,
} from '../blueprint-email-configuration.dao';

class BlueprintEmailConfigurationDAO extends IBlueprintEmailConfigurationDAO {
    static readonly emailConfiguration =
        'account/{accountId}/blueprint/{blueprintId}/email-configuration';
    static readonly emailConfigurationDefaults =
        'account/{accountId}/blueprint/{blueprintId}/email-configuration/defaults';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getEmailConfigurations(
        params: IBlueprintEmailRequestParams
    ): Promise<IBlueprintEmailConfigurationForm> {
        const response = await this.apiClient.get<IBlueprintEmailConfigurationForm>(
            BlueprintEmailConfigurationDAO.emailConfiguration,
            params
        );
        return response.parsedResponse;
    }

    public async getDefaultEmailConfigurations(
        params: IBlueprintEmailRequestParams
    ): Promise<IBlueprintEmailConfigurationForm> {
        const response = await this.apiClient.get<IBlueprintEmailConfigurationForm>(
            BlueprintEmailConfigurationDAO.emailConfigurationDefaults,
            params
        );
        return response.parsedResponse;
    }

    public async updateEmailConfigurations(
        params: IBlueprintEmailRequestParams & IBlueprintEmailConfigurationForm
    ): Promise<IBlueprintEmailConfigurationForm> {
        const response = await this.apiClient.put<IBlueprintEmailConfigurationForm>(
            BlueprintEmailConfigurationDAO.emailConfiguration,
            params
        );
        return response.parsedResponse;
    }
}

export { BlueprintEmailConfigurationDAO };
